<script>
  import SelectInput from "./Inputs/SelectInput.svelte";

  let options = ["One", "Two", "Really long option to test", "Medium Option"];

  let kinds = [
    { variant: "narrow", label: "Narrow" },
    { variant: "default", label: "Default" },
    { variant: "medium", label: "Medium" },
    { variant: "wide", label: "Wide" },
    { variant: "ultrawide", label: "Ultra-Wide" },
  ];
</script>

<div class="border border-red-500 m-4 p-4 bg-white flex flex-col gap-y-2">
  {#each kinds as kind}
    <div class="max-w-min">
      <SelectInput optional {options} {...kind} />
    </div>
  {/each}
</div>
